import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import { REVIEW_RESPONSE_STATUS_PENDING, REVIEW_RESPONSE_STATUS_SUBMITTED } from '../../constants';
import { isReviewResponseEmpty } from '../ReviewsTable/ReviewsTable.utils';

export function isReviewResponsePending(reviewResponse) {
  return _get(reviewResponse, 'status') === REVIEW_RESPONSE_STATUS_PENDING;
}

export function isReviewResponseSubmitted(reviewResponse) {
  return _get(reviewResponse, 'status') === REVIEW_RESPONSE_STATUS_SUBMITTED;
}

export function isReviewResponseChanged(reviewResponse, replyText) {
  if (isReviewResponseEmpty(reviewResponse)) {
    return false;
  }

  const { content } = reviewResponse;
  return content !== replyText;
}

export function getAuthorTextPhoto(author) {
  if (!_isEmpty(author)) {
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(author)}&background=random`;
  }

  return '';
}
